import moment from 'moment'

export const formatStatementPeriod = (dateString?: string) => {
  const endOfMonth = moment(dateString).endOf('month')
  const month = endOfMonth.format('MMM')
  const endDay = endOfMonth.daysInMonth()
  return `${month} 01 - ${month} ${endDay}, ${endOfMonth.year()}`
}
